module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei2.svg";